import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { getPlayers, sendForm } from '../../api';
import PlayerPicker from '../../components/PlayerPicker';

const inp = { padding: '8px 11px', borderRadius: 7, border: '1px solid var(--border-strong)', background: 'var(--bg-app)', color: 'var(--text-primary)', fontSize: 13, outline: 'none', width: '100%', boxSizing: 'border-box', fontFamily: 'inherit' };

export default function SendFormModal({ form, onClose, onSent }) {
  const [players, setPlayers] = useState([]);
  const [target, setTarget] = useState('squad');
  const [selectedIds, setSelectedIds] = useState([]);
  const [deadline, setDeadline] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    getPlayers().then(p => setPlayers((p || []).filter(pl => pl.active !== false)));
  }, []);

  const handleSend = async () => {
    setError('');
    if (target === 'players' && !selectedIds.length) { setError('Select at least one player.'); return; }
    setSaving(true);
    try {
      await sendForm(form.id, {
        target,
        player_ids: target === 'players' ? selectedIds : undefined,
        deadline: deadline ? new Date(deadline).toISOString() : null,
      });
      onSent();
    } catch (err) {
      setError(err.message || 'Failed to send form.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 24 }}>
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 16, width: '100%', maxWidth: 440, overflow: 'hidden', boxShadow: '0 40px 80px rgba(0,0,0,0.6)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 24px 16px', borderBottom: '1px solid var(--border)' }}>
          <h3 style={{ color: 'var(--text-primary)', fontSize: 15, fontWeight: 700, margin: 0 }}>Send "{form.title}"</h3>
          <button onClick={onClose} style={{ background: 'transparent', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', display: 'flex', padding: 4, borderRadius: 6 }}><X size={18} /></button>
        </div>

        <div style={{ padding: '16px 24px 24px', display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 8 }}>Send to</div>
            <div style={{ display: 'flex', gap: 8 }}>
              {[['squad', 'Whole squad'], ['players', 'Individual players']].map(([val, label]) => (
                <button key={val} onClick={() => setTarget(val)}
                  style={{ flex: 1, padding: '8px 10px', borderRadius: 8, border: `1px solid ${target === val ? '#2563eb' : 'var(--border-strong)'}`, background: target === val ? '#2563eb' : 'transparent', color: target === val ? '#fff' : 'var(--text-secondary)', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>
                  {label}
                </button>
              ))}
            </div>
          </div>

          {target === 'players' && (
            <div>
              <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 8 }}>Players</div>
              <PlayerPicker players={players} selectedIds={selectedIds} onChange={setSelectedIds} />
            </div>
          )}

          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 8 }}>Deadline (optional)</div>
            <input type="datetime-local" value={deadline} onChange={e => setDeadline(e.target.value)} style={inp} />
          </div>

          {error && <p style={{ color: '#ef4444', fontSize: 13, margin: 0 }}>{error}</p>}

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 6 }}>
            <button onClick={onClose} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'transparent', color: 'var(--text-secondary)', cursor: 'pointer', fontSize: 13 }}>Cancel</button>
            <button disabled={saving} onClick={handleSend}
              style={{ padding: '8px 18px', borderRadius: 8, border: 'none', background: '#2563eb', color: '#fff', cursor: saving ? 'default' : 'pointer', fontSize: 13, fontWeight: 600 }}>
              {saving ? 'Sending…' : 'Send'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
